/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The different types of reward configuration available
 */
export type RewardConfigurationType =
  (typeof RewardConfigurationType)[keyof typeof RewardConfigurationType]

export const RewardConfigurationType = {
  SINGLE_FUEL_PENCE: "SINGLE_FUEL_PENCE",
  DUAL_FUEL_PENCE: "DUAL_FUEL_PENCE",
} as const
